export default __webpack_public_path__ + "static/media/swoosh-middle.ef88b421.svg";